(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/views/draws.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/views/draws.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.tt.views.Draws = Marionette.View.extend({

    className: 'tt-matchlist',

    ui: {
      inputField: '.tt-input-copy',
      copyButtons: '.js-copy-button'
    },

    modelEvents: {
      change: 'render'
    },

    events: {
      'focus @ui.inputField': 'selectText'
    },

    template: function(data) {
      return svs.tt.templates[
        data.productSetting.productTemplateName
      ](data);
    },

    templateContext: function() {
      var isTopptipset =
        this.model.get('productSetting').productName.toLowerCase() ===
        'topptipset';
      var isPowerplay =
        this.model.get('productSetting').productName.toLowerCase() ===
        'powerplay';
      var isFulltraff =
        this.model.get('productSetting').productName.toLowerCase() ===
        'fullträff';
      return {
        ownRowsCopy: isTopptipset || isPowerplay || isFulltraff
      };
    },

    initialize: function() {
      this.model.fetch();
    },

    selectText: function(e) {
      e.target.select();
    },

    onDomRefresh: function() {
      if (this.ui.copyButtons.length > 0) {
        this.ui.copyButtons.each(function(index, button) {
          this.cp = new window.Clipboard(button);
          this.cp.on('success', function() {
            var branding = svs.core.detect.tenant('tb') ? svs.components.dialog.branding.TUR : svs.components.dialog.branding.SPORT;
            svs.components.dialog.api.add(new svs.components.dialog.Confirm({
              branding: branding,
              type: svs.components.dialog.type.DEFAULT,
              icon: 'thumbs-up',
              title: 'Texten har kopierats till Urklipp',
              actions: [
                {
                  title: 'Okej'
                }
              ]
            }));
          });
        });
      }
    }
  });
})(Backbone, _, svs);


 })(window);